import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { updateFavoriteGamesAction } from 'js/components/system/App/store/actions';

export const useUpdateFavorites = ({ code }) => {
    const dispatch = useDispatch();

    return useCallback(
        (isFavorite) => dispatch(updateFavoriteGamesAction({ code, isFavorite })),
        [code, dispatch]
    );
};
